import { GenesysDevIcon, GenesysDevIcons } from 'genesys-dev-icons';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { PrismAsync as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

import CopyButton from '../copybutton/CopyButton';

import './CodeFence.scss';
import AppSettings from '../../helpers/settings/AppSettings';

declare global {
	interface Window {
		Prism: any;
	}
}

interface IProps {
	value: string;
	noCollapse?: boolean;
	noHeader?: boolean;
	autoCollapse?: boolean;
	title?: string;
	language?: string;
	showLineNumbers?: boolean;
	indentation?: string;
	className?: string;
	jsonEditor?: boolean;
	innerRef?: any;
	sizeKb?: number;
}

export default function CodeFence(props: IProps) {
	const [collapsed, setCollapsed] = useState(props.noCollapse ? false : props.autoCollapse || false);
	const syntaxHighlightingAllowed = useRecoilValue(AppSettings.allowSyntaxHighlightingAtom());
	const syntaxHighlightingLimitKb = useRecoilValue(AppSettings.syntaxHighlightingLimitKbAtom());

	const bodyClassNames: string[] = ['fence-body'];
	if (props.jsonEditor) bodyClassNames.push('json-editor-body');

	const classNames: string[] = ['fence'];
	if (props.className) classNames.push(props.className);
	if (props.noCollapse) classNames.push('nocollapse');
	if (props.indentation) classNames.push(`indent-${props.indentation}`);
	if (props.jsonEditor) classNames.push('json-editor-fence');

	let displaySyntaxHighlighting: boolean = true;
	if (props.sizeKb && (!syntaxHighlightingAllowed || props.sizeKb > syntaxHighlightingLimitKb)) {
		displaySyntaxHighlighting = false;
		bodyClassNames.push('no-highlight-container');
	}

	return (
		<div className={classNames.join(' ')}>
			{props.noHeader || typeof props.value !== 'string' ? (
				''
			) : (
				<div
					className={`fence-header${props.noCollapse ? '' : ' clickable'}`}
					onClick={() => setCollapsed(props.noCollapse ? false : !collapsed)}
				>
					{/* this is a row-reverse flexbox, the JSX is meant to be backwards */}
					{props.noCollapse ? undefined : (
						<GenesysDevIcon icon={collapsed ? GenesysDevIcons.AppChevronDown : GenesysDevIcons.AppChevronUp} />
					)}
					<CopyButton copyText={props.value} />
					<span className="fence-title">{props.title}</span>
				</div>
			)}
			{collapsed ? undefined : (
				<div ref={props.innerRef || undefined} className={bodyClassNames.join(' ')}>
					{displaySyntaxHighlighting ? (
						<SyntaxHighlighter language={props.language?.toLowerCase()} style={vscDarkPlus} showLineNumbers={props.showLineNumbers}>
							{props.value}
						</SyntaxHighlighter>
					) : (
						<div className="no-highlight-content">
							<pre>{props.value}</pre>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
